import type React from "react";
import { useState } from "react";
import { Button, Form } from "rsuite";
import { useLoginUserMutation } from "../../entities/User/userApi";
import "./LoginPage.scss";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { setAuthToken, setUser } from "../../entities/Auth/authApi";
import { Logo } from "../../shared/components/Logo/Logo";
import { formClass } from "../../shared/helpers";

export const LoginPage: React.FC = () => {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [loginUser] = useLoginUserMutation();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const handleLogin = async () => {
		try {
			const result = await loginUser({ email, password }).unwrap();

			if (result.message === "success") {
				dispatch(setAuthToken(result.token));
				dispatch(
					setUser({
						userId: result._id,
						firstName: result.firstName,
						lastName: result.lastName,
						email: result.email,
						score: result.score,
					}),
				);
				navigate("/courses");
			}
		} catch (error) {
			console.error("Failed to login:", error);
		}
	};

	const prefixClass = "login";

	return (
		<div className={formClass(prefixClass)}>
			<Logo />
			<Form>
				<Form.Group>
					<Form.ControlLabel>Email</Form.ControlLabel>
					<Form.Control
						type="email"
						name="email"
						value={email}
						onChange={(value: string) => setEmail(value)}
					/>
				</Form.Group>
				<Form.Group>
					<Form.ControlLabel>Password</Form.ControlLabel>
					<Form.Control
						type="password"
						name="password"
						value={password}
						onChange={(value: string) => setPassword(value)}
					/>
				</Form.Group>
				<Button block size="md" appearance="primary" onClick={handleLogin}>
					Login
				</Button>
				<p className={formClass(prefixClass, "register")}>
					If you don&apos;t have an account, please{" "}
					<Link to="/register">register</Link>
				</p>
			</Form>
		</div>
	);
};
